import { groundOpsAccess } from '@/utils/groundOpsAccess'

const communicationRoles = ['general_manager']
const insuranceRoles = ['general_manager', 'support']
const queues = [
  { path: 'upcoming', queue: 'upcoming', title: 'Communication: Upcoming' },
  { path: 'needs-attention', queue: 'needs_attention', title: 'Communication: Needs attention' },
  { path: 'completed', queue: 'completed', title: 'Communication: Completed' }
]
export default {
  path: '/ground-ops',
  component: () => import('@/views/ground-ops/Index'),
  redirect: { name: 'ground-ops-insurance-updates' },
  children: [
    {
      path: 'insurance-updates',
      name: 'ground-ops-insurance-updates',
      component: () => import('@/views/ground-ops/insurance-updates/List'),
      meta: { title: 'Insurance updates', roles: insuranceRoles, access: groundOpsAccess('insurance_updates') }
    },
    {
      path: 'communication',
      name: 'ground-ops-communication',
      redirect: { name: 'ground-ops-communication-upcoming' },
      meta: { title: 'Communication', roles: communicationRoles, access: groundOpsAccess('communication') }
    },
    ...queues.map(({ path, queue, title }) => ({
      path: `communication/${path}`,
      name: `ground-ops-communication-${path}`,
      component: () => import('@/views/ground-ops/communication/List'),
      props: { queue },
      meta: { title, roles: communicationRoles, access: groundOpsAccess('communication') }
    })),
    {
      path: 'communication/templates',
      name: 'ground-ops-communication-templates',
      component: () => import('@/views/ground-ops/communication/List'),
      props: { queue: 'templates' },
      meta: { title: 'Communication: Templates', roles: communicationRoles, access: groundOpsAccess('communication', 'manage_templates') }
    }
  ]
}
